import UserRoleSelect from 'Components/Common/UserRoleSelect/UserRoleSelect';
import { useUpdateUserRoleMutation } from 'api/entityEndpoints';
import { UserRole } from 'api/dtos/user';
import useGetUserPermission from 'hooks/useGetUserPermission';
import useGetUser from 'hooks/useGetUser';

type Props = {
    id: string;
    role: UserRole;
}

const EntityRole = ({
    id,
    role,
}: Props) => {
    const user = useGetUser();
    const [update, { isLoading }] = useUpdateUserRoleMutation();
    const { isAdmin, isOwner } = useGetUserPermission();

    const updateUserRole = async (updatedRole: UserRole, callback?: () => void) => {
        try {
            await update({
                userId: user?.id ?? '',
                entityId: id,
                role: {
                    role: updatedRole,
                },
            });
            callback?.();
        } catch (e: unknown) {
            // already handled by RTK Query
        }
    };

    return (
        <UserRoleSelect isDisabled={!isAdmin || isOwner} id={id} role={role} isLoading={isLoading} onSelectRole={updateUserRole} />
    );
};

export default EntityRole;
